import { defineStore } from 'pinia';
import type { setType, GetConfigFn } from '../types';

// 默认配置获取函数
let getConfig: GetConfigFn = () => ({
  Title: '',
  FixedHeader: true,
  HiddenSideBar: false,
});

/**
 * 设置配置获取函数
 */
export function setSettingsConfig(configFn: GetConfigFn) {
  getConfig = configFn;
}

export const useSettingStore = defineStore({
  id: 'vue3-admin-setting',
  state: (): setType => ({
    title: getConfig().Title || '',
    fixedHeader: getConfig().FixedHeader ?? true,
    hiddenSideBar: getConfig().HiddenSideBar ?? false,
  }),
  getters: {
    getTitle(): string {
      return this.title;
    },
    getFixedHeader(): boolean {
      return this.fixedHeader;
    },
    getHiddenSideBar(): boolean {
      return this.hiddenSideBar;
    },
  },
  actions: {
    CHANGE_SETTING({ key, value }: { key: string; value: any }) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.hasOwnProperty(key)) {
        (this as any)[key] = value;
      }
    },
    changeSetting(data: { key: string; value: any }) {
      this.CHANGE_SETTING(data);
    },
  },
});

// 导出快捷 hook
export const useSettingStoreHook = () => useSettingStore();

// 导出 hook 函数创建器
export function createSettingStoreHook(store: any) {
  return function () {
    return useSettingStore(store);
  };
}
